<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('serviceRequest.generateTitle') }}</h1>
      <ts-breadcrumb :items="[
        { text: $t('home'), href: '/' },
        {
          text: $t('serviceRequest.pageTitle'),
          href: '/admin/service-requests'
        },
        {
          text: $t('serviceRequest.generateTitle'),
          active: true
        }
      ]" />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <div>
            <Info v-model="model" :validate="errors" ref="info" />
          </div>
          <div>
            <Detail v-model="model" ref="invoiceDetail" />
          </div>
          <div class="row ts-mt-4">
            <div class="col-md-12 ts-space-x-4 ts-flex ts-justify-end">
              <ts-button @click.prevent="$router.push({ name: 'service-request' })">{{ $t('cancel') }}</ts-button>
              <ts-button color="primary" @click.prevent="onSave">{{
                $t('save')
              }}</ts-button>
            </div>
          </div>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import Info from './components/generate-invoice/info.vue'
import Detail from './components/generate-invoice/detail.vue'

export default {
  name: 'serviceRequestGenerateInv',
  components: {
    Info,
    Detail
  },
  data() {
    return {
      loading: false,
      errors: new Errors(),
      model: {
        generate_date: moment().format('DD-MM-YYYY'),
        service_request_id: undefined,
        seller_id: null,
        vendor_customer_id: null,
        customer_id: null,
        payment_method_id: 1,
        bank_name: null,
        account_number: null,
        account_name: null,
        fx_rate_thb: 32,
        fx_rate_kh: 4000,
        remarks: null,
        credit_day: null,

        customer_discount: 0,
        customer_total_after_discount: 0,
        customer_vat_rate: 0,
        customer_vat_amount: 0,

        customer_sub_total: 0,
        customer_grand_total: 0,

        vendor_discount: 0,
        vendor_total_after_discount: 0,
        vendor_vat_rate: 0,
        vendor_vat_amount: 0,

        vendor_sub_total: 0,
        vendor_grand_total: 0,

        details: []
      }
    }
  },
  computed: {},
  methods: {
    ...mapActions('serviceManagement/serviceRequest', [
      'getFormViewModel',
      'generateInv'
    ]),
    onSave() {
      this.loading = true
      this.generateInv(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'service-request' })
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    async getPreData() {
      this.loading = true
      await this.getFormViewModel({
        index: undefined,
        params: {
          fnName: 'serviceRequests'
        }
      })
      this.loading = false
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('serviceManagement/serviceRequest/SET_EDIT_DATA', [])
    next()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.getPreData()
    })
  }
}
</script>
<style scoped>
* {
  font-family: Roboto, Khmer, 'Font Awesome 5 Free';
}
</style>
